import { reatomAsync } from "@reatom/async";
import { API } from "src/api";

import { getMeTelegramRequest } from "./getMeTelegram";

export const logoutTelegramRequest = reatomAsync(
  () => {
    return API.telegramApi
      .telegramControllerLogoutTelegram()
      .then((response) => response.data);
  },
  {
    name: "logoutTelegram",
    onFulfill: (ctx) => {
      getMeTelegramRequest(ctx);
    },
  },
);
